import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "综艺", to: "/category/variety" },
  { label: "关于我们", to: "/about" },
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname, location.search]);

  const handleSearch = (event: React.FormEvent) => {
    event.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setKeyword("");
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/60 bg-background-50/90 backdrop-blur-md">
      <div className="flex h-16 items-center justify-between gap-4 px-4 md:px-8">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-play-fill text-xl" />
          </span>
          <span className="font-heading text-xl font-600 tracking-wide text-foreground-950">
            91<span className="text-accent-500">在线视频</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `rounded-md px-4 py-2 text-sm transition-colors duration-200 ${
                  isActive
                    ? "bg-primary-500/15 text-accent-500"
                    : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <form
            onSubmit={handleSearch}
            className="hidden items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-1.5 md:flex"
          >
            <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
              <i className="ri-search-line text-sm" />
            </span>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视作品"
              className="w-32 bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-400 lg:w-44"
            />
          </form>

          <Link
            to="/favorites"
            aria-label="我的收藏"
            className="hidden h-9 w-9 items-center justify-center rounded-full border border-background-200 text-foreground-600 transition-colors hover:border-accent-500 hover:text-accent-500 sm:flex"
          >
            <i className="ri-heart-line text-lg" />
          </Link>

          <button
            type="button"
            aria-label="菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 text-foreground-700 lg:hidden"
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200/60 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          <form
            onSubmit={handleSearch}
            className="mb-3 flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-3 py-2"
          >
            <span className="flex h-4 w-4 items-center justify-center text-foreground-400">
              <i className="ri-search-line text-sm" />
            </span>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视作品"
              className="w-full bg-transparent text-sm text-foreground-950 outline-none placeholder:text-foreground-400"
            />
          </form>
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 text-sm transition-colors ${
                    isActive
                      ? "bg-primary-500/15 text-accent-500"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <NavLink
              to="/favorites"
              className={({ isActive }) =>
                `rounded-md px-3 py-3 text-sm transition-colors ${
                  isActive
                    ? "bg-primary-500/15 text-accent-500"
                    : "text-foreground-700 hover:bg-background-100"
                }`
              }
            >
              我的收藏
            </NavLink>
          </nav>
        </div>
      )}
    </header>
  );
}